import { useState } from 'react';

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import Typescript from '@mui/material/Typography'

import Title from '../../components/Title'
import Text from '../../components/Text'

import icon_1 from '../../images/icones/slider/beobachten.png'
import icon_2 from '../../images/icones/slider/erkennen.png'
import icon_3 from '../../images/icones/slider/aufnehmen.png'
import icon_4 from '../../images/icones/slider/senden.png'
import icon_5 from '../../images/icones/slider/labor.png'

function IconRow() {
  
  return (

    <Container className="border-t-2 border-b-2 border-slate-950 border-dotted py-2 bgwhite" >

      <Grid container flexDirection="row" justifyContent="space-evenly" spacing={0}>

        <Grid container flexDirection="column" alignItems="center" size={{ xs: 12, sm: 2, md: 2 }}>

          <Grid>
            <div className="logo">
              <img src={icon_1} className="iconlogo"></img>
            </div>
          </Grid>

          <Grid className="center">
            <Text text="iconrow_nr1_verb" variant="title" color="orange"></Text>
          </Grid>

          <Grid className="center">
            <Text text="iconrow_nr1_text" variant="normal" color="green"></Text>
          </Grid>

        </Grid>

        <Grid container flexDirection="column" alignItems="center" size={{ xs: 12, sm: 2, md: 2 }}>
          <Grid>
            <div className="logo">
              <img src={icon_2} className="w-20"></img>
            </div>
          </Grid>

          <Grid className="center">
            <Text text="iconrow_nr2_verb"  variant="title" color="orange"></Text>
          </Grid>
          
          <Grid className="center">
            <Text text="iconrow_nr2_text" variant="normal" color="green"></Text>
          </Grid>

        </Grid>

        <Grid container flexDirection="column" alignItems="center" size={{ xs: 12, sm: 2, md: 2 }}>
          <Grid>
            <div className="logo">
              <img src={icon_3} className="w-20"></img>
            </div>
          </Grid>

          <Grid className="center">
            <Text text="iconrow_nr3_verb"  variant="title" color="orange"></Text>
          </Grid>
          
          <Grid className="center">
            <Text text="iconrow_nr3_text"  variant="normal" color="green"></Text>
          </Grid>

        </Grid>

        <Grid container flexDirection="column" alignItems="center" size={{ xs: 12, sm: 2, md: 2 }}>
          <Grid>
            <div className="logo">
              <img src={icon_4} className="w-20"></img>
            </div>
          </Grid>

          <Grid className="center">
            <Text text="iconrow_nr4_verb"  variant="title" color="orange"></Text>
          </Grid>
          
          <Grid className="center">
            <Text text="iconrow_nr4_text"  variant="normal" color="green"></Text>
          </Grid>

        </Grid>

        <Grid container flexDirection="column" alignItems="center" size={{ xs: 12, sm: 2, md: 2 }}>
          <Grid>
            <div className="logo_brown" sx={{bgcolor: 'primary'}}>
              <img src={icon_5} className="w-20"></img>
            </div>
          </Grid>

          <Grid className="center">
            <Text text="iconrow_nr5_verb" variant="title" color="orange"></Text>
          </Grid>

          <Grid className="center">
            <Text text="iconrow_nr5_text" variant="normal" color="black"></Text>
          </Grid>
          
        </Grid>

      </Grid>


    </Container>
  );
}

export default IconRow;
